import { render } from "./PayorInformation.vue?vue&type=template&id=600b3010&ts=true"
import script from "./PayorInformation.ts?vue&type=script&lang=ts&external"
export * from "./PayorInformation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__